import { NgModule , ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PublicSharedRoutingModule } from './public-shared.routhing';
import { PublicSharedComponent } from './public-shared.component';
import { SharedFilesComponent } from './shared-files.component';
import { EnvironmentSpecificResolver } from '../../environment-specific-resolver.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NbLayoutModule, NbCardModule, NbButtonModule, NbInputModule, NbCheckboxModule, NbIconModule } from '@nebular/theme';
import { PublicSharedService } from './public-shared.services';
import { PublicSharedLiveService } from './public-shared-live.services';
import { Http } from '../shared/http-client/http-client.component'
import { FilePreviewComponent } from './file-preview.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import {VgCoreModule} from '@videogular/ngx-videogular/core';
import {VgControlsModule} from '@videogular/ngx-videogular/controls';
import {VgOverlayPlayModule} from '@videogular/ngx-videogular/overlay-play';
import {VgBufferingModule} from '@videogular/ngx-videogular/buffering';
import { SharedModule } from '../shared/shared.module';
import { SharedLiveView } from './shared-live-view.component';
import { SafePipeModule } from 'safe-pipe';

@NgModule({
  declarations: [
    PublicSharedComponent,
    SharedFilesComponent,
    FilePreviewComponent,
    SharedLiveView
  ],
  imports: [
    CommonModule,
    PublicSharedRoutingModule,
    NbLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    NbLayoutModule,
    NbCardModule,
    NbButtonModule,
    NbInputModule,
    NbCheckboxModule,
    NbIconModule,
    PdfViewerModule,
    VgCoreModule,
    VgControlsModule,
    VgOverlayPlayModule,
    VgBufferingModule,
    SharedModule,
    SafePipeModule
  ],
  providers: [
    EnvironmentSpecificResolver,
    Http,
    PublicSharedService,
    PublicSharedLiveService
  ]
})
export class PublicSharedModule {
    static forRoot(): ModuleWithProviders<PublicSharedModule> {
        return {
            ngModule: PublicSharedModule,
            providers: [],
        };
    }
}
